// extracted by mini-css-extract-plugin
module.exports = {"user_preview":"UserPreview_user_preview__37Iq5","content":"UserPreview_content__15069","rating":"UserPreview_rating__1dDw7","username":"UserPreview_username__Jb-5B"};